const teaProducts = [
  
  {
    id: 1,
    name: 'Darjeeling Tea',
    category: 'Tea',
    image: '/img/dtea1.jpg',
    images: [
      '/img/dtea1.jpg',
      '/img/dtea2.jpg',
      
    ],
    description: 'Darjeeling tea is prized for its light body, floral nose, and signature muscatel notes. It brews a bright golden cup and is preferred for premium loose-leaf service and specialty tea menus.',
    orderUnit: 'kg',
    minOrder: 10,
  },
  {
    id: 2,
    name: 'Assam Tea',
    category: 'Tea',
    image: '/img/at1.jpeg',
    images: [
      '/img/at1.jpeg',
      '/img/at2.jpg',
    ],
    description: 'Assam tea delivers a strong, malty profile with deep amber color and brisk strength. It performs especially well in milk tea blends, daily consumption formats, and high-volume food-service use.',
    orderUnit: 'kg',
    minOrder: 10,
  },
];

export default teaProducts;
